import React,{useState} from 'react';

const MonthlyIncomeVariation = ({ onNext }) => {
  const [clickedButton, setClickedButton] = useState(null);
  const handleClick = (e) => {
    const buttonValue = e.target.value;
    setClickedButton(buttonValue);
    onNext(buttonValue);
  }
  return (
    <>
      <div className="qs-card__head"><h2 className="qs-card__title">Monthly Income Variation</h2></div>
      <div className="qs-card__body">
        <p className="qs-card__sub">Did your monthly income (after tax) change at any point while you held the credit card?</p>
        <div className="qs-stack">
          <button 
            type="button" 
            value={404}
            className={`qs-btn qs-btn--yes qs-btn--full ${clickedButton == 404 ? 'btn-active' : ''}`} 
            onClick={handleClick}
            >Yes
            </button>
          <button 
            type="button" 
            value={405}
            className={`qs-btn qs-btn--outline qs-btn--full ${clickedButton == 405 ? 'btn-active' : ''}`} 
            onClick={handleClick}
            >
              No</button>
          <button 
            type="button"
            value={406} 
            className={`qs-btn qs-btn--outline qs-btn--full ${clickedButton == 406 ? 'btn-active' : ''}`} 
            onClick={handleClick}
            >Not sure</button>
        </div>
      </div>
    </>
  );
};

export default MonthlyIncomeVariation;
